import React from 'react';
import "./style.scss";
import {Link} from "react-router-dom";


export const NotFoundViewView = () => {

    return (
        <div className="error-view-container">
            <div className="error-view">
                <div className="error-view-code">
                    <h1>404</h1>
                </div>
                <h2 className="error-view-header">Страница не найдена</h2>
                <p className="error-view-content">
                    Ресурс, который вы ищете, не найден.
                    Возможна ошибка в маршруте или срок действия ссылки истечен.&nbsp;
                    <Link reloadDocument to={"/"}>Вернуться на главную</Link>
                </p>
            </div>
        </div>
    )
};